/**
 * https://www.pdftron.com/api/web/Core.Document.html#getType__anchor
 */
export default () => window.documentViewer.getDocument().getType();
